import { ISectionListParams } from 'core/model/interfaces/static-pages';
import type { TSliceReducer } from 'core/store';
import type { IStaticPagesState } from './types';

const updateStaticPagesPage: TSliceReducer<IStaticPagesState, number | undefined> = (state, { payload }) => {
  state.sectionList.pagination.currentPage = payload ?? 1;
};

const updateStaticPagesFilters: TSliceReducer<IStaticPagesState, ISectionListParams> = (state, { payload }) => {
  state.filters = { ...state.filters, ...payload };
};

const clearStaticPagesFilters: TSliceReducer<IStaticPagesState> = state => {
  state.filters = {};
};

const clearStaticPagesForm: TSliceReducer<IStaticPagesState> = state => {
  state.form.loading = false;
  state.form.success = false;
};

export const reducers = {
  updateStaticPagesPage,
  updateStaticPagesFilters,
  clearStaticPagesFilters,
  clearStaticPagesForm,
};
